import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ddai_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

/* ---------- Public ---------- */
export async function fetchContent() {
  const res = await axios.get(`${API}/content`);
  return res.data;
}

export async function fetchVideos() {
  const res = await axios.get(`${API}/videos`);
  return res.data;
}

export async function submitContact(data) {
  const res = await axios.post(`${API}/contact`, data);
  return res.data;
}

export async function subscribeNewsletter(data) {
  const res = await axios.post(`${API}/newsletter`, data);
  return res.data;
}

/* ---------- Admin ---------- */
export async function adminLogin(password) {
  const res = await axios.post(`${API}/admin/login`, { password });
  return res.data; // { token }
}

export async function adminVerify() {
  const res = await axios.get(`${API}/admin/verify`, authHeaders());
  return res.data;
}

export async function updateContent(updates) {
  const res = await axios.put(`${API}/admin/content`, updates, authHeaders());
  return res.data;
}

export async function fetchAdminVideos() {
  const res = await axios.get(`${API}/admin/videos`, authHeaders());
  return res.data;
}

export async function createVideo(data) {
  const res = await axios.post(`${API}/admin/videos`, data, authHeaders());
  return res.data;
}

export async function updateVideo(id, data) {
  const res = await axios.put(`${API}/admin/videos/${id}`, data, authHeaders());
  return res.data;
}

export async function deleteVideo(id) {
  const res = await axios.delete(`${API}/admin/videos/${id}`, authHeaders());
  return res.data;
}

export async function getSubmissions() {
  const res = await axios.get(`${API}/admin/submissions`, authHeaders());
  return res.data;
}

export async function getSubscribers() {
  const res = await axios.get(`${API}/admin/subscribers`, authHeaders());
  return res.data;
}

/* ---------- Chunked video upload ---------- */
const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB chunks to stay under proxy limits

export async function uploadVideoFile(file, onProgress) {
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const { data: start } = await axios.post(
    `${API}/admin/upload/start`,
    { filename: file.name, totalChunks, size: file.size },
    authHeaders()
  );
  const uploadId = start.uploadId;
  for (let i = 0; i < totalChunks; i++) {
    const blob = file.slice(i * CHUNK_SIZE, Math.min(file.size, (i + 1) * CHUNK_SIZE));
    const fd = new FormData();
    fd.append("uploadId", uploadId);
    fd.append("chunkIndex", i);
    fd.append("chunk", blob, file.name);
    await axios.post(`${API}/admin/upload/chunk`, fd, authHeaders());
    if (onProgress) onProgress(Math.round(((i + 1) / totalChunks) * 100));
  }
  const { data: done } = await axios.post(`${API}/admin/upload/complete`, { uploadId }, authHeaders());
  return done.url; // e.g. /api/uploads/abc123.mp4
}
